const typography = {
  fontFamily: 'iranyekan',
  typography: {
    fontFamily: '"iranyekan", "roboto"',
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '14px',
  },
  subtitle2: {
    fontWeight: 300,
    fontSize: '12px',
    lineHeight: '14px',
  },
  body1: {
    fontWeight: 200,
    fontSize: '12px',
    lineHeight: '14px',
  },
  body2: {
    fontSize: '11px',
    lineHeight: '18px',
  },
  span: {
    fontSize: '10px',
    lineHeight: '18px',
  },
};

export default typography;
